import {ActionWithPayload} from './index';
import {
  ORDER_LOAD_SUCCESS,
  ORDER_LOAD_FAIL,
  ORDER_IS_LOADING,
  ORDER_DOCUMENTS_LOAD,
  DISABLE_INVOICE,
  ORDER_COMPLETION_CLEAR
} from "@store/actions";
import {AppState} from "@store/reducers/index";
import {CLEAR_ORDER_COMPLETION_STATE} from "@store/actions/order-complition.action";

export enum DocumentType {
  Label = 'label',
  Receipt = 'receipt'
}
export interface Document {
  type: DocumentType;
  link: string;
  id: string;
}
export interface OrderDocumentsState {
  receipts: Document[];
  labels: Document[];
}

export interface OrderCompletionState {
  data: {
    currency_format: any;
    order: any;
    shipments: any;
    user: any,
  };
  parameters: any;
  loading: boolean;
  loaded: boolean;
  documents: OrderDocumentsState;
  order_id: string;
  disabled_invoice: boolean;
}

export function orderCompletionReducer (
  state = {
    order: null,
    data: null,
    parameters: null,
    loading: false,
    loaded: false,
    documents: {},
    order_id: null,
    disabled_invoice: false,
  }, action: ActionWithPayload<OrderCompletionState>) {
  switch (action.type) {
    case ORDER_IS_LOADING:
      return {
        ...state,
        parameters: action.payload.parameters,
        loading: true,
        order_id: null
      };
    case ORDER_LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        parameters: null,
        loading: false,
        loaded: true,
        documents: {},
        order_id: null,
        disabled_invoice: false,

      };
    case ORDER_LOAD_FAIL:
      return {
        ...state,
        data: null,
        loading: false,
        loaded: false,
        order_id: action.payload && action.payload.order_id,
      };
    case DISABLE_INVOICE:
      return {
        ...state,
        disabled_invoice: true,
      };
    case ORDER_DOCUMENTS_LOAD:
      return {
        ...state,
        documents: action.payload.documents
      };
    case ORDER_COMPLETION_CLEAR:
      return {
        data: null,
        parameters: null,
        loading: false,
        loaded: false,
        documents: {},
        order_id: null,
        disabled_invoice: false,
      };

    case CLEAR_ORDER_COMPLETION_STATE:
      return {
        data: null,
        parameters: null,
        loading: false,
        loaded: false,
        documents: {},
        order_id: null,
        disabled_invoice: false,
      }
    default:
      return state;
  }
}

export const selectOrderCompletion = (state: AppState) => state.orderCompletion;



// WEBPACK FOOTER //
// ./src/app/store/reducers/order-completion.reducer.ts